/* eslint-disable max-len */
import * as React from 'react';


export const LabsLogoWhite = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={205}
      height={40}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)" filter="url(#b)">
        <path
          fill="#42B3FF"
          d="M15.38 29.595a.75.75 0 0 1-1.06 0l-4.59-4.59a.75.75 0 0 1 0-1.06l5.12-5.12 5.65 5.65-5.12 5.12Z"
        />
        <path
          fill="#FFB800"
          d="M26.68 29.595a.75.75 0 0 1-1.06 0l-5.12-5.12 5.65-5.65 5.12 5.12a.75.75 0 0 1 0 1.06l-4.59 4.59Z"
        />
        <path
          fill="#fff"
          d="m20.5 24.475-5.65-5.65 5.65-5.65 5.65 5.65-5.65 5.65Z"
        />
        <path
          fill="#FF6428"
          d="m20.5 13.175-5.12-5.12a.75.75 0 0 1 0-1.06l4.59-4.59a.75.75 0 0 1 1.06 0l4.59 4.59a.75.75 0 0 1 0 1.06l-5.12 5.12Z"
        />
        <path
          fill="#fff"
          d="m160.015 24 2.867-16.106h1.882L161.897 24h-1.882Zm8.551.269c-.836 0-1.523-.135-2.06-.403-.523-.284-.911-.657-1.165-1.12a3.178 3.178 0 0 1-.359-1.479c.015-.821.247-1.523.695-2.105.463-.598 1.112-1.053 1.949-1.367.836-.328 1.799-.493 2.889-.493h2.979c.12-.701.105-1.276-.044-1.724-.135-.463-.389-.807-.762-1.03-.373-.225-.851-.337-1.434-.337-.731 0-1.396.187-1.993.56-.598.359-1.023.889-1.277 1.59h-1.949c.239-.806.627-1.485 1.165-2.038a5.471 5.471 0 0 1 1.949-1.254 6.269 6.269 0 0 1 2.352-.448c1.015 0 1.837.186 2.464.56.627.373 1.06.903 1.299 1.59.254.672.299 1.471.134 2.397L174.211 24h-1.68l.224-1.994a4.71 4.71 0 0 1-.739.896 5.578 5.578 0 0 1-.941.717 4.08 4.08 0 0 1-1.142.47 4.96 4.96 0 0 1-1.367.18Zm.56-1.59c.538 0 1.053-.105 1.546-.314a4.61 4.61 0 0 0 1.299-.874c.388-.373.695-.791.919-1.254.224-.463.336-.941.336-1.434v-.045h-2.823c-.702 0-1.314.098-1.837.292-.507.179-.896.44-1.164.784-.254.328-.389.731-.404 1.21 0 .507.18.91.538 1.209.373.284.903.425 1.59.425Zm14.041 1.59c-.597 0-1.15-.105-1.657-.314a4.345 4.345 0 0 1-1.299-.806 3.635 3.635 0 0 1-.784-1.053L178.911 24h-1.702l2.845-16.106h1.881l-1.187 6.72c.448-.522 1.016-.985 1.703-1.388.701-.404 1.553-.605 2.553-.605.971 0 1.792.216 2.464.65.687.417 1.21.992 1.568 1.724.359.732.538 1.56.538 2.487a7.442 7.442 0 0 1-.515 2.665 6.96 6.96 0 0 1-1.367 2.173 6.05 6.05 0 0 1-2.016 1.434 6.13 6.13 0 0 1-2.509.515Zm.068-1.635c.851 0 1.597-.21 2.24-.628a4.456 4.456 0 0 0 1.545-1.77c.388-.746.59-1.582.605-2.508 0-.672-.127-1.27-.381-1.792a2.831 2.831 0 0 0-1.053-1.232c-.463-.299-1.023-.448-1.68-.448-.851 0-1.605.224-2.262.672-.657.433-1.187 1.03-1.59 1.792-.389.747-.59 1.59-.605 2.531 0 .672.127 1.262.381 1.77.253.508.619.903 1.097 1.187.478.284 1.045.426 1.703.426Zm12.122 1.635c-.926 0-1.718-.157-2.375-.47-.657-.33-1.15-.785-1.478-1.367-.329-.597-.463-1.292-.403-2.083h1.904c-.015.403.059.784.224 1.142.164.359.44.65.828.874.404.209.926.313 1.568.313.538 0 1.001-.074 1.389-.224.388-.164.687-.388.896-.672.224-.298.336-.657.336-1.075 0-.328-.097-.59-.291-.784-.194-.209-.478-.38-.851-.515a6.251 6.251 0 0 0-1.277-.358c-.403-.09-.814-.202-1.232-.336a5.404 5.404 0 0 1-1.142-.56c-.329-.224-.59-.5-.784-.83a2.362 2.362 0 0 1-.292-1.186c.015-.672.217-1.27.605-1.792.388-.523.919-.941 1.591-1.255.687-.313 1.456-.47 2.307-.47 1.18 0 2.12.298 2.822.896.717.582 1.046 1.418.986 2.509h-1.882c.03-.568-.142-1.008-.515-1.322-.373-.329-.911-.493-1.613-.493-.687 0-1.254.157-1.702.47-.433.314-.65.703-.65 1.165 0 .3.09.553.269.762.194.194.463.358.806.493.359.12.784.239 1.277.358.463.105.904.232 1.322.381.418.15.791.343 1.12.582.343.224.612.5.806.83.194.328.291.73.291 1.209-.015.776-.231 1.448-.649 2.016-.418.567-.993 1.008-1.725 1.321-.732.314-1.561.47-2.486.47Z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M54.906 8v3.199h-6.938v3.199h6.938v3.198h-6.938v3.199h6.938v3.199H44.5V8h10.406ZM69.65 9.6 67.914 8H57.508v15.998h10.406l1.735-1.6V9.6Zm-3.468 11.2h-5.203v-9.601h5.203V20.799Zm14.743 0V8h3.468v15.998H72.25V8h3.468v12.797h5.203l.002.002Zm9.537-9.601h7.805V8H86.993v15.998h11.273v-3.199h-7.805v-9.6Zm52.031 12.797h-12.141V8h12.141v15.998-.002Zm-3.468-6.4V11.2h-5.203v9.598h5.203V17.596ZM145.094 8H155.5v3.199h-3.468v12.797h-3.468V11.199h-3.468V8h-.002Zm-44.226 0v15.998h3.468v-6.4h5.203v6.4h3.468V8h-12.142.003Zm8.671 6.4h-5.203v-3.201h5.203V14.4Zm18.21 0-1.735 1.6 1.735 1.6V24h-12.141V8h12.141v6.4Zm-5.203 6.4h1.735v-3.2h-5.203v3.2h3.468Zm0-6.4h1.735v-3.201h-5.203v3.199h3.468v.002Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M4.5 0h200v32H4.5z" />
        </clipPath>
        <filter
          id="b"
          width={208}
          height={40}
          x={0.5}
          y={0}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1246_11818"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1246_11818"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export default LabsLogoWhite;
